import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Youtube, Instagram, ArrowUpRight, Play } from "lucide-react";
import { API } from "@/App";
import { SOCIALS } from "@/data/content";

export default function MediaShowcase() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);
  const channel = "https://youtube.com/@bimabachatbazar";
  const instagram = SOCIALS.find((s) => s.name === "Instagram")?.url;

  useEffect(() => {
    axios.get(`${API}/youtube`)
      .then(({ data }) => { setVideos(data.videos || []); setActive((data.videos || [])[0] || null); })
      .catch(() => setVideos([]));
  }, []);

  return (
    <section className="section media-section" data-testid="media-showcase">
      <div className="section-head">
        <div>
          <div className="eyebrow gold">Watch & learn</div>
          <h2>Seedha samjhaye, <span className="accent">video mein.</span></h2>
        </div>
        <p>Financial concepts ko simple Hinglish mein samajhiye — hamare YouTube channel par. New videos yahan automatically aate hain.</p>
      </div>
      <div className="media-grid">
        <motion.div className="media-featured" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          {active ? (
            <div className="video-frame" data-testid="youtube-featured-player">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${active.id}`}
                title={active.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <a className="video-frame video-fallback" href={channel} target="_blank" rel="noopener noreferrer" data-testid="youtube-channel-fallback">
              <Youtube size={48} />
              <strong>Watch on YouTube</strong>
            </a>
          )}
          <div className="video-meta">
            <strong data-testid="youtube-featured-title">{active?.title || "BIMA BACHAT BAZAR on YouTube"}</strong>
            <a href={channel} target="_blank" rel="noopener noreferrer" className="text-link" data-testid="youtube-channel-link"><Youtube size={15} /> Subscribe to channel</a>
          </div>
        </motion.div>
        <div className="media-side">
          {videos.slice(1).map((v) => (
            <button key={v.id} className={active?.id === v.id ? "video-thumb active" : "video-thumb"} onClick={() => setActive(v)} data-testid={`video-thumb-${v.id}`}>
              <span className="thumb-img"><img src={v.thumbnail} alt={v.title} loading="lazy" /><Play size={16} /></span>
              <span className="thumb-text"><strong>{v.title}</strong><small>{v.published}</small></span>
            </button>
          ))}
          <a className="insta-card" href={instagram} target="_blank" rel="noopener noreferrer" data-testid="instagram-card">
            <span className="insta-icon"><Instagram size={20} /></span>
            <span><strong>Instagram par follow karein</strong><small>@bimabachatbazar — daily tips & updates</small></span>
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
